import i18n from 'i18next';

class LabelHelper {
  constructor() {
    this.label = null;
  }

  /**
   * Creates the label background element
   * @param type Type of html element
   * @param width Width of element
   * @param height Height of element
   */
  makeBackground(type, width, height) {

    const hoverBase = document.createElement(type);
    const element = document.createElement(type);
    const overlay = document.createElement(type);
    const background = document.createElement(type);

    overlay.classList = "label-element background-overlay";
    overlay.id = "background-overlay";

    background.classList = "label-element background";

    hoverBase.classList = "label-element hover-base"
    hoverBase.style.width = width + "px";
    hoverBase.style.height = height + "px";

    hoverBase.addEventListener("mouseenter", this.onMouseOver);
    hoverBase.addEventListener("mouseleave", this.onMouseOut);

    element.classList = "label-element label-base";
    element.style.display = "none"

    // "345px 263px"
    hoverBase.appendChild(overlay)
    hoverBase.appendChild(background)
    element.appendChild(hoverBase)



    return element;
  }

  /**
   * Creates the label background element.
   * @param type Type of html element
   * @param width Width of element
   * @param height Height of element
   */
  makeButton(type, width, height) {
    const element = document.createElement(type);
    element.id = "favourite-button";

    element.classList = "label-element favourite-button";
    element.style.backgroundImage =
      "url('design/new-exports/Star_with_plus.png')";
    element.style.backgroundSize = "contain";
    element.style.border = "none";
    element.style.backgroundColor = "rgba(0,0,0,0)";
    element.style.width = width + "px";
    element.style.height = height + "px";
    element.style.cursor = "pointer";
    element.style.backgroundSize = "cover";

    return element;
  }

  /**
   * Creates name of apartment element.
   */
  makeApartmentName() {
    const element = document.createElement("div", 230, 60);
    element.classList = "label-element apartment-name";
    element.style.width = 230 + "px";
    element.style.height = 60 + "px";
    element.style.borderBottom = "1px solid white";

    const labelElement = document.createElement("p", 50, 20);
    labelElement.classList = "label-element name-label";
    labelElement.innerText = i18n.t("APARTMENT");
    labelElement.style.width = 50 + "px";
    labelElement.style.height = 20 + "px";
    labelElement.style.color = "white";
    labelElement.style.fontSize = "12pt";

    const favorisLabelElement = document.createElement("p", 50, 20);
    favorisLabelElement.classList = "label-element favoris";
    favorisLabelElement.innerText = i18n.t("FAVORITES").toUpperCase();
    favorisLabelElement.style.width = 50 + "px";
    favorisLabelElement.style.height = 20 + "px";
    favorisLabelElement.style.color = "white";
    favorisLabelElement.style.fontSize = "8pt";

    const nameTextElement = document.createElement("p", 50, 20);
    nameTextElement.classList = "label-element hotspot-name";
    nameTextElement.innerText = "D 5.1";
    nameTextElement.id = "hotspot-name";
    nameTextElement.style.width = 100 + "px";
    nameTextElement.style.height = 20 + "px";
    nameTextElement.style.color = "white";
    nameTextElement.style.fontSize = "20pt";
    nameTextElement.style.fontWeight = 600;

    element.appendChild(labelElement);
    element.appendChild(favorisLabelElement);
    element.appendChild(nameTextElement);

    return element;
  }

  /**
   * Creates apartment info element.
   */
  makeApartmentInfo() {
    const element = document.createElement("div", 250, 60);
    element.classList = "label-element apartment-info";
    element.style.width = 250 + "px";
    element.style.height = 60 + "px";

    const quadratureElement = document.createElement("p", 200, 20);
    quadratureElement.classList = "label-element info-quadrature";
    quadratureElement.innerText = "75.88 m2 ";
    quadratureElement.id = "quadrature";
    quadratureElement.style.width = 200 + "px";
    quadratureElement.style.height = 20 + "px";
    quadratureElement.style.color = "white";
    quadratureElement.style.fontSize = "12pt";
    quadratureElement.style.fontWeight = "bold";

    const typeElement = document.createElement("p", 200, 20);
    typeElement.classList = "label-element info-type";
    typeElement.innerText = "T4";
    typeElement.id = "apartment-type";
    typeElement.style.width = 200 + "px";
    typeElement.style.height = 20 + "px";
    typeElement.style.color = "white";
    typeElement.style.fontSize = "18pt";
    typeElement.style.fontWeight = 700;


    const priceElement = document.createElement("p", 200, 20);
    priceElement.classList = "label-element info-type";
    priceElement.id = "apartment-price";
    priceElement.style.width = 200 + "px";
    priceElement.style.height = 20 + "px";
    priceElement.style.left = 105 + "px";
    priceElement.style.top = 4 + "px";
    priceElement.style.color = "white";
    priceElement.style.fontSize = "15pt";
    priceElement.style.fontWeight = 700;

    const typeLongElement = document.createElement("p", 200, 20);
    typeLongElement.classList = "label-element info-type-long";
    typeLongElement.innerHTML = "4 bed </br> apartment";
    typeLongElement.id = "apartment-type-long";
    typeLongElement.style.width = 200 + "px";
    typeLongElement.style.height = 20 + "px";
    typeLongElement.style.color = "white";
    typeLongElement.style.fontSize = "12pt";
    typeLongElement.style.lineHeight = "12pt";

    element.appendChild(quadratureElement);
    element.appendChild(typeElement);
    element.appendChild(typeLongElement);
    element.appendChild(priceElement);


    return element;
  }

  /**
   * Creates details button element.
   * @param width 
   * @param height 
   */
  makeDetailsButton(width, height) {
    const element = document.createElement("button");
    element.id = "details-button";

    element.classList = "label-element details-button";
    element.innerText =  i18n.t("MORE_DETAILS").toUpperCase();
    element.style.border = "none";
    element.style.color = "gray";
    element.style.backgroundColor = "white";
    element.style.width = width + "px";
    element.style.height = height + "px";
    element.style.cursor = "pointer";
    element.style.fontSize = "8pt";
    element.style.borderRadius = "15px";
    element.style.fontWeight = 700;

    return element;
  }

  /**
   * Creates hidden details button element.
   * @param width 
   * @param height 
   */
  makeHiddenDetailsButton(width, height) {
    const element = document.createElement("button");
    element.id = "hidden-details-button";

    element.classList = "label-element hidden-details-button";
    element.style.border = "none";
    element.style.backgroundColor = "rgba(1,1,1,0)";
    element.style.width = width + "px";
    element.style.height = height + "px";
    element.style.cursor = "pointer";

    return element;
  }

  /**
   * Turns off display of label.
   */
  hideLabel() {
    if (!this.label) return
    this.label.style.display = "none"

  }
  displayLabel(shouldDisplayLabel) {
    if (!this.label) return
    if (shouldDisplayLabel) {
      this.label.style.display = "block"
      return
    }
    this.label.style.display = "none"

  }
  /**
   * Turns on display of label.
   */
  showLabel() {
    this.label.style.display = "block"
  }

  /**
   * Dispatches label mouseover event.
   */
  onMouseOver() {
    const event = new CustomEvent("labelIsHovered");
    let fullscreenNode = document.getElementById("full-screenable-node");
    fullscreenNode.dispatchEvent(event);
  }

  /**
   * Dispatches label mouseout event.
   */
  onMouseOut() {
    const event = new CustomEvent("labelMouseOut");
    let fullscreenNode = document.getElementById("full-screenable-node");
    fullscreenNode.dispatchEvent(event);
  }

  /**
   * Returs the color for a particular apartment from data from the API.
   * @param projectJSON Whole project json returned from the API
   * @param apartment Object containing the info of an apartment
   */
  getHotspotLabelColor(projectJSON, apartment) {


    if (!projectJSON.hotspotColors[apartment.type]) return;

    const color = apartment.hoverCloudColor ? apartment.hoverCloudColor : projectJSON.hotspotColors[apartment.type].hoverColor;
    return color
  }

  /**
   * Updates the info displayed on the label depending on which hotspot is being hovered.
   * @param key Key of the hotspot being hovered
   * @param currentState Index of current state
   * @param favouriteApartments List of keys of favourited apartments
   * @param projectJSON Whole project json returned from the API
   */
  updateHotspotInfo(key, currentState, favouriteApartments, projectJSON) {
    const hotspotName = document.getElementById("hotspot-name");
    const backgroundOverlay = document.getElementById("background-overlay");

    const quadrature = document.getElementById("quadrature");
    const apartmentType = document.getElementById("apartment-type");
    const apartmentPrice = document.getElementById("apartment-price");
    const apartmentTypeLong = document.getElementById("apartment-type-long");
    const favouriteButton = document.getElementById("favourite-button");

    if (favouriteButton === null) return
    //const state = this.info.states[currentState];
    const state = projectJSON.states[currentState]


    state.apartments.forEach(async (apartment) => {

      if (apartment.key === key) {
        backgroundOverlay.style.backgroundColor = await this.getHotspotLabelColor(projectJSON, apartment)
        hotspotName.innerText = apartment.name;
        quadrature.innerText = `${apartment.quadrature}㎡`;
        apartmentType.innerText = apartment.type;
        apartmentTypeLong.innerHTML = `${i18n.t("APARTMENT").toLocaleLowerCase()} <br/>${apartment.type[1]} ${apartment.type[1] === "1" ? i18n.t("PIECE").toLowerCase() : i18n.t("PIECES").toLowerCase()}`;



        if (apartment.showApartmentPrice) {
          apartmentPrice.innerText = apartment.price + apartment.currencySymbol; //TODO implement currency type
          return;
        }
        apartmentPrice.innerText = "";

      }
    });
    if (favouriteApartments.includes(key)) {
      favouriteButton.style.backgroundImage = "url('design/new-exports/Star_with_minus.png')";
    } else {
      favouriteButton.style.backgroundImage = "url('design/new-exports/Star_with_plus.png')";
    }
  }

  moveLabel(mousePosition) {
    this.label.style.top = `${mousePosition.positionY - 220}px`;
    this.label.style.left = `${mousePosition.positionX - 300}px`;
  }

  /**
   * Creates label and appends all children elements.
   * @param camera Three js camera used to render the main canvas
   */
  createLabel() {
    const fullscreenNode = document.getElementById("full-screenable-node")

    let background = this.makeBackground("div", 365, 263);

    const apartmentName = this.makeApartmentName();
    const apartmentInfo = this.makeApartmentInfo();
    const button = this.makeButton("button", 43, 40);
    const detailsButton = this.makeDetailsButton(105, 30);
    const hiddenDetailsButton = this.makeHiddenDetailsButton(105, 85);
    background.children[0].appendChild(button);
    background.children[0].appendChild(detailsButton);
    background.children[0].appendChild(hiddenDetailsButton);
    background.children[0].appendChild(apartmentName);
    background.children[0].appendChild(apartmentInfo);
    fullscreenNode.appendChild(background)

    this.label = background;
    return this.label;
  }
}

export default new LabelHelper();
